import styled, { keyframes } from 'styled-components';
import { LogoSvg } from './LogoSvg';

export const Logo = styled(LogoSvg)`
  display: block;
  max-width: 9rem;
  margin: 0;

  animation-name: ${keyframes`
    0% {
      opacity: 0;
      transform: translate3d(0, 1rem, 0);
    }
    100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  `};
  animation-duration: 400ms;
  animation-timing-function: ease-in-out;
`;
